import { Order } from '@diamond/shared/types';

export type PaymentInstructionPagePhase =
  | { status: 'waiting' }
  | { status: 'ready'; order: Order }
  | { status: 'error' };

export interface ResolvePaymentInstructionPagePhaseInput {
  routerReady: boolean;
  flagLoading: boolean;
  flagEnabled: boolean;
  isPending: boolean;
  isFetching: boolean;
  order: Order | undefined;
  hasError: boolean;
}

export const resolvePaymentInstructionPagePhase = ({
  routerReady,
  flagLoading,
  flagEnabled,
  isPending,
  isFetching,
  order,
  hasError,
}: ResolvePaymentInstructionPagePhaseInput): PaymentInstructionPagePhase => {
  const hasAmbiguousCachedSubState =
    !order || order.payment_sub_state === null;

  if (
    !routerReady ||
    flagLoading ||
    isPending ||
    (flagEnabled && isFetching && hasAmbiguousCachedSubState)
  ) {
    return { status: 'waiting' };
  }

  if (hasError || !order) {
    return { status: 'error' };
  }

  return { status: 'ready', order };
};
